import * as actionTypes from './authActionTypes';

export const login = (userID, username, languageCode, roles) => ({type: actionTypes.LOGIN, username:username, languageCode:languageCode, roles: roles});
export const logout = () => ({type: actionTypes.LOGOUT});
